import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function NoExperience() {
  return <section className="py-20 md:py-28 bg-zinc-950 border-y border-zinc-900" data-id="element-184">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-186">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-500/10 border border-blue-500/20 text-blue-400 rounded-full mb-6" data-id="element-187">
            <Sparkles className="w-6 h-6" data-id="element-188" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-6" data-id="element-189">
            No necesitás experiencia previa
          </h2>
          <div className="space-y-4 text-lg text-zinc-400 leading-relaxed" data-id="element-190">
            <p data-id="element-191">
              La guía está pensada para que puedas entender el sistema desde
              cero. Vas a aprender cómo analizar el negocio, elegir qué modelos
              publicar, crear ofertas simples, preparar anuncios y llevar
              personas interesadas a conversación para vender.
            </p>
            <p data-id="element-192">
              No hace falta que seas experto en Meta Ads ni que tengas una
              tienda grande. La idea es que entiendas cómo funciona la
              publicidad aplicada específicamente al negocio de iPhones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}